import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  height: '100%',
};

export const button: SxStyle = {
  textTransform: 'none',
};

export const leftSection: SxStyle = {
  borderRightWidth: 1,
  borderRightStyle: 'solid',
  borderRightColor: (p) => p.palette.grey[300],
  paddingRight: (p) => p.spacing(1.5),
  flex: 2,
};

export const rightSection: SxStyle = {
  paddingLeft: (p) => p.spacing(1.5),
  flex: 3,
};
